import {forwardRef} from 'react'
import {Button, type ButtonProps} from '@/components/ui/button'
import {cn} from '@/lib/utils'

type RowHoverButtonProps = ButtonProps

/**
 * Button that stays hidden until the nearest ancestor with `group` class is hovered.
 * Used for row-level quick actions (edit, trigger, etc.) in tables where actions
 * should not clutter the default view. Wrap the `<tr>` with `className="group"`.
 */
export const RowHoverButton = forwardRef<HTMLButtonElement, RowHoverButtonProps>(function RowHoverButton(
    {className, variant = 'ghost', size = 'sm', ...rest},
    ref,
) {
    return (
        // eslint-disable-next-line testid/require-testid -- caller passes data-testid via `...rest`
        <Button
            ref={ref}
            variant={variant}
            size={size}
            className={cn('opacity-0 group-hover:opacity-100 transition-opacity', className)}
            {...rest}
        />
    )
})
